"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomId = exports.sleep = exports.CONST_DEBUG = void 0;
exports.CONST_DEBUG = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? true : false;
exports.sleep = function (ms) { return new Promise(function (resolve) { return setTimeout(resolve, ms); }); };
exports.randomId = function () { return Math.random().toString(36); };
